import React from 'react';
import SafeImage from '../../../../elements/SafeImage';

function DirectoryItemLogo(props) {
    const {className = '', item} = props;

    if (!item.image_url) return null;

    return <SafeImage className={className} src={item.image_url} />;
}

export default DirectoryItemLogo;
